/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_ContinueInputs */

const en_onboarding_continue = /** @type {(inputs: Onboarding_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const fr_onboarding_continue = /** @type {(inputs: Onboarding_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Onboarding_ContinueInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_continue = /** @type {((inputs?: Onboarding_ContinueInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_ContinueInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_continue(inputs)
	return fr_onboarding_continue(inputs)
});